import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

import { initialState } from "../store/slices/userSlice";

const useRewards = () => {

  const userState = useSelector((state) => state.userState);
  const systemState = useSelector((state) => state.systemState);

  const [rewardsInState, setRewardsInState] = useState({
    ...initialState.rewards,
  });

  const appSettings = systemState.settings;
  const currency = appSettings.currency ?? "";

  const addDiscountText = (pArray) => {
    const newArray = pArray.map((element) => {
      let discountText;
      let discountValue;
      try {
        discountValue = element.discount_value ?? 0;
      } catch (err) {
        discountValue = 0;
      }
      discountValue = discountValue.toFixed(2);

      if (element.discount_type === "P") {
        discountValue = element.discount_value.toFixed(0);
        discountText = `-${discountValue}%`;
      } else if (element.discount_type === "F") {
        discountText = `${discountValue} ${currency}`;
      } else if (element.discount_type === "V") {
        discountText = `-${discountValue} ${currency}`;
      }

      return { ...element, discountText: discountText };
    });

    return newArray;
  };

  useEffect(() => {
    const cupons = addDiscountText(userState.rewards.cupons);
    const tierRewards = addDiscountText(userState.rewards.tierRewards);

    setRewardsInState({ cupons, tierRewards });
  }, [userState, currency]);

  return rewardsInState;
};

export default useRewards;
